module.exports = __webpack_public_path__ + "img/image-placeholder.27ea510f.png";